import { useIntl } from '@/intl'

import { busesSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { space } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { useMemo } from 'react'
import { styled } from 'styled-components'

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${space('primitives_space_8')};
`

export function OutboundTitle() {
  const intl = useIntl()
  const { outboundBuses } = usePricesSelector(busesSelector)

  const outboundDates = useMemo(() => {
    return outboundBuses[0]?.departureDate && outboundBuses[0]?.arrivalDate
      ? {
          departureDate: intl.formatDate(outboundBuses[0].departureDate.rawDate, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          }),
          arrivalDate: intl.formatDate(outboundBuses[0].arrivalDate.rawDate, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          }),
        }
      : {}
  }, [outboundBuses])

  const hasDates = outboundDates.departureDate && outboundDates.arrivalDate
  const hasDifferentDates = outboundDates.departureDate !== outboundDates.arrivalDate

  return (
    <TitleWrapper>
      <Typography variant="body-l-bold-tight">
        {intl.formatMessage({ id: 'prices_transport_selector_bus-selector_outbound_trip' })}
      </Typography>
      {hasDates && hasDifferentDates && <Typography variant="body-m-regular-tight">{`${outboundDates.departureDate} - ${outboundDates.arrivalDate}`}</Typography>}
      {hasDates && !hasDifferentDates && <Typography variant="body-m-regular-tight">{outboundDates.departureDate}</Typography>}
    </TitleWrapper>
  )
}

export function InboundTitle() {
  const intl = useIntl()
  const { inboundBuses } = usePricesSelector(busesSelector)

  const inboundDates = useMemo(() => {
    return inboundBuses[0]?.departureDate && inboundBuses[0]?.arrivalDate
      ? {
          departureDate: intl.formatDate(inboundBuses[0].departureDate.rawDate, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          }),
          arrivalDate: intl.formatDate(inboundBuses[0].arrivalDate.rawDate, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          }),
        }
      : {}
  }, [inboundBuses])

  const hasDates = inboundDates.departureDate && inboundDates.arrivalDate
  const hasDifferentDates = inboundDates.departureDate !== inboundDates.arrivalDate

  return (
    <TitleWrapper>
      <Typography variant="body-l-bold-tight">
        {intl.formatMessage({ id: 'prices_transport_selector_bus-selector_inbound_trip' })}
      </Typography>
      {hasDates && hasDifferentDates && <Typography variant="body-m-regular-tight">{`${inboundDates.departureDate} - ${inboundDates.arrivalDate}`}</Typography>}
      {hasDates && !hasDifferentDates && <Typography variant="body-m-regular-tight">{inboundDates.departureDate}</Typography>}
    </TitleWrapper>
  )
}
